






































































































import Vue from "vue";

// Components
import YTSidebarItem from "./YTSidebarItem.vue";

export default Vue.extend({
	name: "YTSidebar",
	props: {
		type: {
			type: String,
			default: "full",
			validator(v) {
				return ["full", "mini", "fixed"].includes(v);
			},
		},
		expanded: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		YTSidebarItem,
	},
	data() {
		return {
			mainNavs: [
				{
					name: "Home",
					icon: "home",
					path: "/apps/cloned/youtube",
				},
				{
					name: "Trending",
					icon: "local_fire_department",
				},
				{
					name: "Subscriptions",
					icon: "subscriptions",
				},
			],
			userNavs: [
				{
					name: "Libraby",
					icon: "video_library",
				},
				{
					name: "History",
					icon: "restore",
				},
				{
					name: "Your Videos",
					icon: "slideshow",
				},
				{
					name: "Watch Later",
					icon: "watch_later",
				},
				{
					name: "Liked Videos",
					icon: "thumb_up",
				},
			],
			subscriptions: [
				{
					name: "Old Signature",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwngFvOT-6Y0u3CTZNFw2qcwlBLZmZh7QAeyZrHSs=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Funzoa",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwnjN93Q64_fhdHIBcFf69m76h5wlYJKaUei3b2HEIA=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Sanam",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwnjE3KIfwjX51EWbucmpLmfv9yA7F7ZyIqlaqfq8ng=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Avash",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwnj_m4T7JmznRkDDgU97oViQjhp0jS0EFobvCVtfQw=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Old Signature",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwngFvOT-6Y0u3CTZNFw2qcwlBLZmZh7QAeyZrHSs=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Funzoa",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwnjN93Q64_fhdHIBcFf69m76h5wlYJKaUei3b2HEIA=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Sanam",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwnjE3KIfwjX51EWbucmpLmfv9yA7F7ZyIqlaqfq8ng=s88-c-k-c0x00ffffff-no-rj",
				},
				{
					name: "Avash",
					thumb:
						"https://yt3.ggpht.com/ytc/AAUvwnj_m4T7JmznRkDDgU97oViQjhp0jS0EFobvCVtfQw=s88-c-k-c0x00ffffff-no-rj",
				},
			],
		};
	},
	computed: {
		classes() {
			return {
				"w-60": ["full", "fixed"].includes(this.type),
				"w-16 scrollbar-thin": this.type === "mini",
				"-left-60": !this.expanded,
				"left-0 shadow-xl": this.expanded,
			};
		},
	},
});
